export default [
    {
        path: '/find-provider',
        name: 'public.find-provider',
        view: 'public/FindProvider',
    },

    {
        path: `/find-provider/results`,
        name: 'public.find-provider.results',
        view: 'public/FindProviderResults',
        default: { query: { limit: 6 } },
    },
]
